import React from "react";
import { RouteObject } from "react-router-dom";
import { MainLayout } from "./components/MainLayout/MainLayout";
import { LandingPage } from "./pages/LandingPage/index";
import { Features } from "./pages/Features";
import { Solutions } from "./pages/Solutions";
import { Pricing } from "./pages/Pricing";
import { About } from "./pages/About";
import { Contact } from "./pages/Contact";
import { Privacy } from "./pages/Privacy/Privacy";
import { Terms } from "./pages/Terms/Terms";
import { Security } from "./pages/Security/Security";
import { ErrorBoundary } from "../../errors/ErrorBoundary";
export const mainRoutes: RouteObject[] = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { index: true, element: <LandingPage /> },
      { path: "features", element: <Features /> },
      { path: "solutions", element: <Solutions /> },
      // { path: "pricing", element: <Pricing /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "privacy", element: <Privacy /> },
      { path: "terms", element: <Terms /> },
      { path: "security", element: <Security /> },
    ],
    errorElement: <ErrorBoundary />,
  },
];
